const exportedObject = {
  api: {
    baseUrl: "https://cabinet.maxbonus.ru/cloud/service.php",
    baseHost: "https://cabinet.maxbonus.ru",
  },
}

export default exportedObject;
